<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { TableHeaderField, TableDataField, type ITableField } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { visitHistoryDtoFields } from "../../utils/TableFields/visit-dto.fields";
  import {
    loading,
    records,
    initList,
    startEditingNote,
    editingNote,
    saveNote,
    markItemUnlockedGood,
    markItemUnlockedBurn,
    load,
  } from "./visit-history-detail.store";
  import Button from "../../components/Button.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";

  export let date: string;

  let colspanValue = visitHistoryDtoFields.length + 1;
  let visibleFields = visitHistoryDtoFields;

  function renderField(field: ITableField<any>, record: any) {
    if (field.render != null && typeof field.render === "function") {
      return field.render(record);
    }
    return record[field.name];
  }

  onMount(() => {
    initList(date);
  });
</script>

<MainLayout>
  <SearchHeader entitySingular="capo" entityPlural="capi" searchFieldVisible={false} numRecords={$records != null ? $records.length : 0}>
    <!--
    <div slot="search" class="level-item weight-label-search-box">
      <p class="control" style="margin-left:1rem;">
        <Button klass="is-warning" on:click={load}>
          <span>Aggiorna</span>
        </Button>
      </p>
    </div>
    -->
  </SearchHeader>

  <table class="table is-striped is-fullwidth table-base">
    <thead>
      <tr>
        {#each visibleFields as field}
          <TableHeaderField klass={field.titleClass || ""} sortable={field.sortable}>
            {field.title}
          </TableHeaderField>
        {/each}
        <TableHeaderField klass="table-buttons"></TableHeaderField>
      </tr>
    </thead>

    <tbody>
      {#if $loading == false}
        {#if $records.length == 0}
          <tr class="table-no-data">
            <td colspan={colspanValue}> nessun elemento da visualizzare </td>
          </tr>
        {:else}
          {#each $records as record}
            <tr
              class:visit-item-worked={record.worked == 1 && record.viewed == 0}
              class:visit-item-viewed={record.worked == 1 && record.viewed == 1 && record.locked == 0 && record.passed == 1}
              class:visit-item-locked={record.worked == 1 && record.viewed == 1 && record.locked == 1}
              class:visit-item-discarded={record.worked == 1 && record.viewed == 1 && record.locked == 0 && record.passed == 0}
              class:visit-item-skipped={record.skipped == 1}
            >
              {#each visibleFields as field}
                <TableDataField klass={field.dataClass || ""}>
                  {@html renderField(field, record)}
                </TableDataField>
              {/each}
              <TableDataField klass="has-text-centered">
                {#if record.viewed == 1 && record.locked == 0}
                  {#if record.passed == 1}
                    <p>Approvato da: {record.passSignUserName}</p>
                  {:else}
                    <p>Scartato da: {record.burnSignUserName}</p>
                  {/if}
                {/if}
                {#if record.locked == 1}
                  <p>Vincolato da: {record.lockSignUserName}</p>
                  <Button klass="is-light" style="width:10rem;" on:click={(_) => markItemUnlockedGood(record)}>Svincola</Button>
                  <Button klass="is-danger" style="width:10rem;" on:click={(_) => markItemUnlockedBurn(record)}>Scarta</Button>
                {/if}
              </TableDataField>
            </tr>
            <tr>
              <td colspan={colspanValue - 1}>
                {#if $editingNote === record.slaughterItemOid}
                  <Input name="" placeholder="inserire le note per questo capo" bind:value={record.vetNotes} />
                {:else}
                  <span class="visit-item-notes-label">Note:</span>&nbsp;{record.vetNotes}
                {/if}
              </td>
              <TableDataField klass="has-text-centered">
                {#if $editingNote === record.slaughterItemOid}
                  <Button klass="is-light" style="width:10rem;" on:click={(_) => saveNote(record)}>Salva note</Button>
                {:else}
                  <Button klass="is-light" style="width:10rem;" disabled={record.worked == 0} on:click={(_) => startEditingNote(record)}>Modifica note</Button>
                {/if}
              </TableDataField>
            </tr>
          {/each}
        {/if}
      {:else}
        <tr class="table-no-data">
          <td colspan={colspanValue}>
            <div class="table-loader" />
          </td>
        </tr>
      {/if}
    </tbody>
  </table>
</MainLayout>

<style>
  .table-base {
    margin-top: 1.5rem;
  }

  .table-base tr.table-no-data {
    transition: all 1s linear;
  }

  tr.visit-item-worked {
    background-color: rgba(255, 217, 0, 0.74) !important;
  }
  tr.visit-item-viewed {
    background-color: rgba(0, 166, 0, 0.74) !important;
  }
  tr.visit-item-locked {
    background-color: rgba(200, 0, 200, 0.74) !important;
  }
  tr.visit-item-skipped {
    background-color: rgba(200, 30, 30, 0.74) !important;
  }
  tr.visit-item-discarded {
    background-color: rgba(200, 30, 30, 0.74) !important;
  }

  .visit-item-notes-label {
    font-weight: bold;
  }
</style>
